import './style.css'
import { LANGUAGES, COUNTRY_LANGUAGE_MAP, MESSAGES } from './i18n.js'

const MAX_PROMPT_LENGTH = 1800
const CHATGPT_BASE_URL = 'https://chatgpt.com/'
const SPEEDS = {
  fast: { min: 12, max: 27 },
  normal: { min: 24, max: 55 },
  slow: { min: 45, max: 95 },
}
const SPEED_LABEL_KEYS = { fast: 'speedFast', normal: 'speedNormal', slow: 'speedSlow' }

const app = document.querySelector('#app')
const params = new URLSearchParams(window.location.search)
const sharedPrompt = normalizePrompt(params.get('q') || '')
const demoMode = params.get('demo') === '1'
const selectedSpeed = SPEEDS[params.get('speed')] ? params.get('speed') : 'normal'
let currentLocale = 'en'
let languageMode = 'auto'

const icons = {
  spark: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8L12 2Z"/><path d="m19 15 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"/></svg>`,
  arrow: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`,
  copy: `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="11" height="11" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></svg>`,
  check: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>`,
  external: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 5h5v5M19 5l-8 8"/><path d="M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/></svg>`,
  share: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4"/></svg>`,
  moon: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 15.3A9 9 0 1 1 8.7 4a7 7 0 0 0 11.3 11.3Z"/></svg>`,
  sun: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>`,
  back: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>`,
  pause: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5v14M15 5v14"/></svg>`,
  play: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7V5Z"/></svg>`,
  menu: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>`,
  plus: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>`,
  edit: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z"/></svg>`,
  microphone: `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3M9 21h6"/></svg>`,
  sliders: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></svg>`,
  aiKnot: `<svg viewBox="0 0 24 24" aria-hidden="true" class="ai-knot-svg"><g fill="none" stroke="currentColor" stroke-width="1.55"><ellipse cx="12" cy="7.2" rx="3.15" ry="5.15"/><ellipse cx="12" cy="7.2" rx="3.15" ry="5.15" transform="rotate(60 12 12)"/><ellipse cx="12" cy="7.2" rx="3.15" ry="5.15" transform="rotate(120 12 12)"/><ellipse cx="12" cy="7.2" rx="3.15" ry="5.15" transform="rotate(180 12 12)"/><ellipse cx="12" cy="7.2" rx="3.15" ry="5.15" transform="rotate(240 12 12)"/><ellipse cx="12" cy="7.2" rx="3.15" ry="5.15" transform="rotate(300 12 12)"/></g></svg>`,
  sidebar: `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2.5"/><path d="M9 4v16"/></svg>`,
  search: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/></svg>`,
  image: `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="3"/><circle cx="9" cy="9" r="1.5"/><path d="m5 17 4.2-4.2 3.1 3 2.2-2.2L19 18"/></svg>`,
  plugin: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3v4M16 3v4M6 7h12v4a6 6 0 0 1-6 6 6 6 0 0 1-6-6V7ZM12 17v4"/></svg>`,
  investigation: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 18V6l13-3v15"/><path d="m4 13 13-3M17 8l3 1v8l-3 1"/><circle cx="8" cy="18" r="3"/></svg>`,
  gear: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6 1.7 1.7 0 0 0 10 3V2.8h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z"/></svg>`,
  help: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.8 9a2.4 2.4 0 1 1 3.7 2c-.9.6-1.5 1-1.5 2.2M12 17h.01"/></svg>`,
  badge: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.2 2.2 3.1-.4.4 3.1L20 10l-2.3 2.1-.4 3.1-3.1-.4L12 17l-2.2-2.2-3.1.4-.4-3.1L4 10l2.3-2.1.4-3.1 3.1.4L12 3Z"/><path d="m9.5 10 1.6 1.6 3.4-3.4"/></svg>`,
  arrowUp: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 19V5M6 11l6-6 6 6"/></svg>`,
  stop: `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="8" height="8" rx="1.5" fill="currentColor" stroke="none"/></svg>`,
  more: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="18" cy="12" r="1" fill="currentColor" stroke="none"/></svg>`,
}


const languageCodes = new Set(LANGUAGES.map((language) => language.code))

function normalizeLanguageCode(value) {
  if (!value) return null
  const normalized = String(value).trim().replace('_', '-')
  if (languageCodes.has(normalized)) return normalized
  const lower = normalized.toLowerCase()
  if (lower.startsWith('pt')) return 'pt-BR'
  if (lower.startsWith('zh')) return 'zh-CN'
  const base = lower.split('-')[0]
  return languageCodes.has(base) ? base : null
}

function t(key, variables = {}) {
  const template = MESSAGES[currentLocale]?.[key] ?? MESSAGES.en[key] ?? key
  return Object.entries(variables).reduce(
    (text, [name, value]) => text.replaceAll(`{${name}}`, String(value)),
    template,
  )
}

function getLanguageName(code = currentLocale) {
  return LANGUAGES.find((language) => language.code === code)?.name || code
}

function getStoredLanguage() {
  try { return normalizeLanguageCode(localStorage.getItem('lmaify-language')) } catch { return null }
}

function setStoredLanguage(code) {
  try {
    if (code) localStorage.setItem('lmaify-language', code)
    else localStorage.removeItem('lmaify-language')
  } catch { /* Storage may be disabled. */ }
}

function detectBrowserLanguage() {
  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language]
  for (const candidate of candidates) {
    const supported = normalizeLanguageCode(candidate)
    if (supported) return supported
  }
  return null
}

async function detectCloudflareCountry() {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 900)
  try {
    const response = await fetch('/cdn-cgi/trace', {
      cache: 'no-store',
      headers: { Accept: 'text/plain' },
      signal: controller.signal,
    })
    if (!response.ok) return null
    const trace = await response.text()
    return trace.match(/^loc=([A-Z]{2})$/m)?.[1] || null
  } catch {
    return null
  } finally {
    clearTimeout(timeout)
  }
}

async function detectAutomaticLanguage() {
  const browserLanguage = detectBrowserLanguage()
  if (browserLanguage) return browserLanguage
  const country = await detectCloudflareCountry()
  return COUNTRY_LANGUAGE_MAP[country] || 'en'
}

async function resolveInitialLanguage() {
  const urlLanguage = normalizeLanguageCode(params.get('lang'))
  if (urlLanguage) return { locale: urlLanguage, mode: 'manual' }
  const storedLanguage = getStoredLanguage()
  if (storedLanguage) return { locale: storedLanguage, mode: 'manual' }
  return { locale: await detectAutomaticLanguage(), mode: 'auto' }
}

function applyLocaleMetadata() {
  document.documentElement.lang = currentLocale
  document.documentElement.dir = 'ltr'
  document.querySelector('meta[name="description"]')?.setAttribute('content', t('metaHomeDescription'))
  document.querySelector('meta[property="og:description"]')?.setAttribute('content', t('metaHomeDescription'))
}

function languageSelectorMarkup(variant = 'site') {
  const autoLabel = t('autoDetected', { language: getLanguageName() })
  return `
    <label class="language-picker language-picker--${variant}">
      <span class="sr-only">${t('language')}</span>
      <select data-language-select aria-label="${t('language')}">
        <option value="auto" ${languageMode === 'auto' ? 'selected' : ''}>${autoLabel}</option>
        ${LANGUAGES.map((language) => `<option value="${language.code}" ${languageMode === 'manual' && currentLocale === language.code ? 'selected' : ''}>${language.name}</option>`).join('')}
      </select>
    </label>
  `
}

function updateLanguageQuery(code) {
  const url = new URL(window.location.href)
  if (code) url.searchParams.set('lang', code)
  else url.searchParams.delete('lang')
  window.history.replaceState({}, '', url)
}

async function bindLanguageSelectors() {
  document.querySelectorAll('[data-language-select]').forEach((select) => {
    select.addEventListener('change', async () => {
      if (select.value === 'auto') {
        setStoredLanguage(null)
        updateLanguageQuery(null)
        currentLocale = await detectAutomaticLanguage()
        languageMode = 'auto'
      } else {
        const locale = normalizeLanguageCode(select.value) || 'en'
        setStoredLanguage(locale)
        updateLanguageQuery(locale)
        currentLocale = locale
        languageMode = 'manual'
      }
      applyLocaleMetadata()
      if (sharedPrompt) {
        window.location.reload()
        return
      }
      renderHome()
    })
  })
}

function normalizePrompt(value) {
  const normalized = value.replace(/\r\n/g, '\n').trim()
  return Array.from(normalized).slice(0, MAX_PROMPT_LENGTH).join('')
}

function escapeHtml(value) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;')
}

function buildShareUrl(prompt, speed = 'normal', demo = false) {
  const url = new URL(window.location.href)
  url.search = ''
  url.hash = ''
  url.searchParams.set('q', prompt)
  if (speed !== 'normal') url.searchParams.set('speed', speed)
  if (demo) url.searchParams.set('demo', '1')
  if (languageMode === 'manual') url.searchParams.set('lang', currentLocale)
  return url.toString()
}

function buildChatGptUrl(prompt) {
  const url = new URL(CHATGPT_BASE_URL)
  url.searchParams.set('q', prompt)
  return url.toString()
}

function setTheme(theme) {
  document.documentElement.dataset.theme = theme
  try { localStorage.setItem('lmaify-theme', theme) } catch { /* Storage may be disabled. */ }
  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    const dark = theme === 'dark'
    button.innerHTML = dark ? icons.sun : icons.moon
    button.setAttribute('aria-label', dark ? t('themeLight') : t('themeDark'))
    button.title = dark ? t('themeLight') : t('themeDark')
  })
}

function initTheme() {
  let stored = null
  try { stored = localStorage.getItem('lmaify-theme') } catch { /* Use system preference. */ }
  const preferred = window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
  setTheme(stored || preferred)
}

function bindThemeToggle() {
  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      setTheme(document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark')
    })
  })
}

function logoMarkup() {
  return `
    <a class="brand" href="${window.location.pathname}" aria-label="${t('homeAria')}">
      <span class="brand-mark">${icons.spark}</span>
      <span class="brand-name">Let Me Ask <strong>AI</strong> For You</span>
    </a>
  `
}

function headerMarkup({ compact = false } = {}) {
  return `
    <header class="site-header ${compact ? 'site-header--compact' : ''}">
      ${logoMarkup()}
      <div class="header-actions">
        <span class="privacy-pill"><span></span> ${t('privacyPill')}</span>
        ${languageSelectorMarkup('site')}
        <button class="icon-button" data-theme-toggle type="button" aria-label="${t('themeDark')}"></button>
      </div>
    </header>
  `
}

function renderHome() {
  document.title = t('metaHomeTitle')
  app.innerHTML = `
    <div class="page-shell">
      <div class="ambient ambient-one"></div>
      <div class="ambient ambient-two"></div>
      ${headerMarkup()}

      <main>
        <section class="hero">
          <div class="eyebrow reveal reveal-1"><span>${icons.spark}</span> ${t('eyebrow')}</div>
          <h1 class="reveal reveal-2">${t('heroPrefix')} <span class="gradient-text">${t('heroAccent')}</span><br>${t('heroSuffix')}</h1>
          <p class="hero-copy reveal reveal-3">${t('heroCopy')}</p>

          <div class="generator-card reveal reveal-4">
            <div class="card-glow"></div>
            <form id="prompt-form">
              <div class="field-heading">
                <label for="prompt">${t('questionLabel')}</label>
                <span id="counter">0 / ${MAX_PROMPT_LENGTH}</span>
              </div>
              <div class="prompt-field-wrap">
                <textarea id="prompt" maxlength="${MAX_PROMPT_LENGTH}" rows="5" placeholder="${t('questionPlaceholder')}" autocomplete="off" spellcheck="true"></textarea>
                <span class="typing-caret-decoration" aria-hidden="true"></span>
              </div>

              <div class="form-footer">
                <fieldset class="speed-picker">
                  <legend>${t('typingRhythm')}</legend>
                  <div class="segmented-control">
                    ${Object.entries(SPEEDS).map(([value, item]) => `
                      <label>
                        <input type="radio" name="speed" value="${value}" ${value === 'normal' ? 'checked' : ''}>
                        <span>${t(SPEED_LABEL_KEYS[value])}</span>
                      </label>
                    `).join('')}
                  </div>
                </fieldset>
                <button class="primary-button" id="create-link-button" type="submit" disabled>
                  <span>${t('createMagicLink')}</span>${icons.arrow}
                </button>
              </div>
            </form>
          </div>

          <p class="shortcut-hint reveal reveal-5"><kbd>Ctrl</kbd><span>+</span><kbd>Enter</kbd> ${t('shortcut')}</p>
        </section>

        <section class="result-section" id="result-section" hidden aria-live="polite">
          <div class="result-card">
            <div class="success-orb">${icons.check}</div>
            <div class="result-copy">
              <span class="result-kicker">${t('resultReady')}</span>
              <h2>${t('resultTitle')}</h2>
              <p>${t('resultBody')}</p>
            </div>
            <div class="link-box">
              <input id="share-url" readonly aria-label="${t('resultReady')}">
              <button class="copy-button" id="copy-link" type="button">${icons.copy}<span>${t('copy')}</span></button>
            </div>
            <div class="result-actions">
              <button class="secondary-button" id="preview-link" type="button">${icons.play}<span>${t('preview')}</span></button>
              <button class="secondary-button" id="open-link" type="button">${icons.external}<span>${t('testRealLink')}</span></button>
              <button class="secondary-button" id="share-link" type="button">${icons.share}<span>${t('share')}</span></button>
            </div>
            <div class="prompt-preview" id="prompt-preview"></div>
          </div>
        </section>

        <section class="how-it-works" aria-labelledby="how-title">
          <div class="section-heading">
            <span>${t('simplePurpose')}</span>
            <h2 id="how-title">${t('stepsTitle')}</h2>
          </div>
          <div class="steps-grid">
            <article class="step-card">
              <span class="step-number">01</span>
              <div class="mini-icon">${icons.spark}</div>
              <h3>${t('step1Title')}</h3>
              <p>${t('step1Body')}</p>
            </article>
            <article class="step-card featured-step">
              <span class="step-number">02</span>
              <div class="mini-browser">
                <i></i><i></i><i></i>
                <div class="mini-line"><span></span></div>
              </div>
              <h3>${t('step2Title')}</h3>
              <p>${t('step2Body')}</p>
            </article>
            <article class="step-card">
              <span class="step-number">03</span>
              <div class="mini-icon">${icons.arrow}</div>
              <h3>${t('step3Title')}</h3>
              <p>${t('step3Body')}</p>
            </article>
          </div>
        </section>

        <section class="privacy-section">
          <div class="privacy-visual" aria-hidden="true">
            <div class="orbit orbit-a"></div><div class="orbit orbit-b"></div>
            <div class="shield">${icons.spark}</div>
          </div>
          <div>
            <span class="section-label">${t('privacyLabel')}</span>
            <h2>${t('privacyTitle')}</h2>
            <p>${t('privacyBody')}</p>
          </div>
        </section>
      </main>

      <footer>
        ${logoMarkup()}
        <p>${t('footerIndependent')}</p>
        <a href="https://chatgpt.com" target="_blank" rel="noopener noreferrer">${t('openChatGPT')} ${icons.external}</a>
      </footer>
    </div>
    <div class="toast" id="toast" role="status" aria-live="polite"></div>
  `

  initTheme()
  bindThemeToggle()
  bindLanguageSelectors()
  bindGenerator()
}

function bindGenerator() {
  const form = document.querySelector('#prompt-form')
  const textarea = document.querySelector('#prompt')
  const counter = document.querySelector('#counter')
  const resultSection = document.querySelector('#result-section')
  const submitButton = document.querySelector('#create-link-button')
  const shareInput = document.querySelector('#share-url')
  const promptPreview = document.querySelector('#prompt-preview')
  let currentUrl = ''
  let currentPrompt = ''
  let currentSpeed = 'normal'

  const updateCounter = () => {
    const count = Array.from(textarea.value).length
    counter.textContent = `${count} / ${MAX_PROMPT_LENGTH}`
    counter.classList.toggle('near-limit', count > MAX_PROMPT_LENGTH * 0.85)
    submitButton.disabled = normalizePrompt(textarea.value).length === 0
  }

  updateCounter()
  textarea.addEventListener('input', updateCounter)
  textarea.addEventListener('keydown', (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      event.preventDefault()
      form.requestSubmit()
    }
  })

  form.addEventListener('submit', (event) => {
    event.preventDefault()
    const prompt = normalizePrompt(textarea.value)
    if (!prompt) {
      textarea.focus()
      textarea.closest('.prompt-field-wrap').classList.add('shake')
      showToast(t('toastWritePrompt'))
      setTimeout(() => textarea.closest('.prompt-field-wrap').classList.remove('shake'), 500)
      return
    }

    currentPrompt = prompt
    currentSpeed = new FormData(form).get('speed') || 'normal'
    currentUrl = buildShareUrl(prompt, currentSpeed)
    shareInput.value = currentUrl
    promptPreview.innerHTML = `<span>${t('promptInLink')}</span><p>${escapeHtml(prompt)}</p>`
    resultSection.hidden = false
    requestAnimationFrame(() => resultSection.classList.add('visible'))
    resultSection.scrollIntoView({ behavior: 'smooth', block: 'center' })
  })

  document.querySelector('#copy-link').addEventListener('click', async (event) => {
    if (!currentUrl) return
    const copied = await copyText(currentUrl, shareInput)
    if (copied) {
      const button = event.currentTarget
      button.innerHTML = `${icons.check}<span>${t('copied')}</span>`
      button.classList.add('is-copied')
      showToast(t('toastLinkCopied'))
      setTimeout(() => {
        button.innerHTML = `${icons.copy}<span>${t('copy')}</span>`
        button.classList.remove('is-copied')
      }, 1800)
    }
  })

  document.querySelector('#preview-link').addEventListener('click', () => {
    if (!currentPrompt) return
    window.open(buildShareUrl(currentPrompt, currentSpeed, true), '_blank', 'noopener,noreferrer')
  })

  document.querySelector('#open-link').addEventListener('click', () => {
    if (!currentUrl) return
    window.open(currentUrl, '_blank', 'noopener,noreferrer')
  })

  const shareButton = document.querySelector('#share-link')
  if (!navigator.share) shareButton.hidden = true
  shareButton.addEventListener('click', async () => {
    if (!currentUrl) return
    try {
      await navigator.share({
        title: t('shareTitle'),
        text: t('shareText'),
        url: currentUrl,
      })
    } catch (error) {
      if (error.name !== 'AbortError') showToast(t('toastShareFailed'))
    }
  })
}

async function copyText(text, fallbackInput) {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    try {
      fallbackInput.focus()
      fallbackInput.select()
      return document.execCommand('copy')
    } catch {
      showToast(t('toastManualCopy'))
      return false
    }
  }
}

function showToast(message) {
  const toast = document.querySelector('#toast')
  if (!toast) return
  toast.textContent = message
  toast.classList.add('show')
  clearTimeout(showToast.timeout)
  showToast.timeout = setTimeout(() => toast.classList.remove('show'), 2600)
}

function renderPlayer(prompt) {
  document.title = t('metaPlayerTitle')
  const safePrompt = escapeHtml(prompt)
  app.innerHTML = `
    <div class="player-page">
      <div class="gpt-app-shell">
        <aside class="gpt-sidebar" aria-label="${t('navIllustrative')}">
          <div class="gpt-sidebar-brand-row">
            <a class="gpt-corner-logo" href="${window.location.pathname}" aria-label="${t('createAnother')}">
              ${icons.aiKnot}
            </a>
            <span class="gpt-sidebar-collapse" aria-hidden="true">${icons.sidebar}</span>
          </div>

          <nav class="gpt-sidebar-primary" aria-label="${t('shortcutsIllustrative')}">
            <a class="gpt-sidebar-link" href="${window.location.pathname}">${icons.edit}<span>${t('newChat')}</span></a>
            <span class="gpt-sidebar-link">${icons.search}<span>${t('searchChats')}</span></span>
            <span class="gpt-sidebar-link">${icons.image}<span>${t('images')}</span></span>
            <span class="gpt-sidebar-link">${icons.plugin}<span>${t('plugins')}</span></span>
            <span class="gpt-sidebar-link">${icons.investigation}<span>${t('research')}</span></span>
          </nav>

          <div class="gpt-sidebar-spacer"></div>

          <div class="gpt-sidebar-bottom">
            <nav class="gpt-sidebar-secondary" aria-label="${t('optionsIllustrative')}">
              <span class="gpt-sidebar-link gpt-sidebar-link--arrow">${icons.badge}<span>${t('plans')}</span>${icons.arrow}</span>
              <span class="gpt-sidebar-link">${icons.gear}<span>${t('settings')}</span></span>
              <span class="gpt-sidebar-link gpt-sidebar-link--arrow">${icons.help}<span>${t('help')}</span>${icons.arrow}</span>
            </nav>
            <div class="gpt-login-card">
              <strong>${t('loginTitle')}</strong>
              <p>${t('loginBody')}</p>
              <span class="gpt-login-button gpt-login-button--filled">${t('signIn')}</span>
              <span class="gpt-login-button">${t('signUp')}</span>
            </div>
          </div>
        </aside>

        <section class="gpt-workspace">
          <header class="gpt-topbar">
            <div class="gpt-topbar-left">
              <span class="gpt-mobile-logo" aria-hidden="true">${icons.aiKnot}</span>
              <div class="gpt-model-name">ChatGPT <span>⌄</span></div>
            </div>
            <div class="gpt-auth-actions" aria-hidden="true">
              <span class="gpt-auth-button gpt-auth-button--filled">${t('signIn')}</span>
              <span class="gpt-auth-button">${t('signUp')}</span>
            </div>
          </header>

          <main class="gpt-chat-main">
            <div class="gpt-chat-column">
              <div class="gpt-conversation" id="gpt-conversation" aria-hidden="true">
                <div class="gpt-user-row">
                  <div class="gpt-user-message" id="sent-prompt"></div>
                </div>
                <div class="gpt-assistant-row" id="assistant-loader">
                  <span class="gpt-thinking-dot" aria-hidden="true"></span>
                  <span class="sr-only" id="response-status">${t('statusOpeningConversation')}</span>
                </div>
              </div>

              <div class="gpt-composer-zone">
                <div class="gpt-composer" id="gpt-composer" aria-label="${t('composerAria')}">
                  <div class="gpt-composer-input">
                    <span class="gpt-composer-text" id="typed-prompt" aria-label="${t('questionTyping')}"></span>
                    <span class="caret" id="caret" aria-hidden="true"></span>
                    <span class="gpt-placeholder" id="gpt-placeholder">${t('askAnything')}</span>
                  </div>
                  <div class="gpt-composer-toolbar">
                    <div class="gpt-composer-left">
                      <span class="gpt-round-tool" aria-hidden="true">${icons.plus}</span>
                    </div>
                    <div class="gpt-composer-right">
                      <span class="gpt-round-tool gpt-mic" aria-hidden="true">${icons.microphone}</span>
                      <button class="fake-send" type="button" tabindex="-1" aria-hidden="true">${icons.arrowUp}</button>
                    </div>
                  </div>
                  <div class="typing-progress" aria-hidden="true"><span id="progress-bar"></span></div>
                </div>
                <div class="gpt-disclaimer">${t('disclaimer')}</div>
              </div>
            </div>

            <div class="player-controls player-controls--floating" aria-label="${t('controlsAria')}">
              ${languageSelectorMarkup('player')}
              <button class="ghost-button" id="pause-button" type="button" title="${t('pauseAnimation')}" aria-label="${t('pauseAnimation')}">${icons.pause}<span>${t('pause')}</span></button>
              <button class="ghost-button" id="skip-button" type="button" title="${demoMode ? t('openInChatGPT') : t('skipAnimation')}" aria-label="${demoMode ? t('openInChatGPT') : t('skipAnimation')}">${icons.external}<span>${demoMode ? t('openInChatGPT') : t('skip')}</span></button>
              <a class="ghost-button subtle" href="${window.location.pathname}" title="${t('createAnother')}" aria-label="${t('createAnother')}">${icons.back}<span>${t('createLinkShort')}</span></a>
            </div>

            <span class="sr-only" id="player-status" role="status" aria-live="polite">${t('statusTypingQuestion')}</span>
            <span class="sr-only" id="progress-copy">${t('statusPreparing')}</span>
            <span class="sr-only" id="progress-percent">0%</span>
          </main>
        </section>
      </div>

      <div class="gpt-unofficial-note">${t('unofficialNote')}</div>

      <div class="fallback-card" id="fallback-card" hidden>
        <div class="fallback-icon">${icons.aiKnot}</div>
        <h2>${t('fallbackTitle')}</h2>
        <p>${t('fallbackBody')}</p>
        <a class="primary-button" href="${escapeHtml(buildChatGptUrl(prompt))}">${t('openInChatGPT')} ${icons.arrow}</a>
        <button class="secondary-button" id="copy-prompt" type="button">${icons.copy}<span>${t('copyQuestion')}</span></button>
        <textarea class="sr-only" id="prompt-copy-source">${safePrompt}</textarea>
      </div>
      <div class="toast" id="toast" role="status" aria-live="polite"></div>
    </div>
  `

  bindLanguageSelectors()
  startPlayer(prompt)
}

function splitGraphemes(text) {
  if ('Segmenter' in Intl) {
    return [...new Intl.Segmenter(currentLocale, { granularity: 'grapheme' }).segment(text)].map((item) => item.segment)
  }
  return Array.from(text)
}

function randomBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

function sleep(ms, signal) {
  return new Promise((resolve) => {
    if (signal?.aborted) return resolve()
    const timeout = setTimeout(resolve, ms)
    signal?.addEventListener('abort', () => {
      clearTimeout(timeout)
      resolve()
    }, { once: true })
  })
}

function startPlayer(prompt) {
  const output = document.querySelector('#typed-prompt')
  const progressBar = document.querySelector('#progress-bar')
  const progressPercent = document.querySelector('#progress-percent')
  const progressCopy = document.querySelector('#progress-copy')
  const playerStatus = document.querySelector('#player-status')
  const caret = document.querySelector('#caret')
  const pauseButton = document.querySelector('#pause-button')
  const skipButton = document.querySelector('#skip-button')
  const placeholder = document.querySelector('#gpt-placeholder')
  const composer = document.querySelector('#gpt-composer')
  const conversation = document.querySelector('#gpt-conversation')
  const sentPrompt = document.querySelector('#sent-prompt')
  const responseStatus = document.querySelector('#response-status')
  const sendButton = document.querySelector('.fake-send')
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const chars = splitGraphemes(prompt)
  const timing = SPEEDS[selectedSpeed]
  let paused = false
  let finished = false
  let abortController = new AbortController()

  const setStatus = (message) => {
    playerStatus.textContent = message
  }

  const setProgress = (current) => {
    const percentage = Math.round((current / chars.length) * 100)
    progressBar.style.width = `${percentage}%`
    progressPercent.textContent = `${percentage}%`
  }

  const showSentState = () => {
    sentPrompt.textContent = prompt
    conversation.classList.add('is-visible')
    conversation.setAttribute('aria-hidden', 'false')
    output.textContent = ''
    placeholder.hidden = false
    caret.classList.add('done')
    composer.classList.remove('is-sending')
    composer.classList.add('is-sent')
    sendButton.classList.remove('ready')
    sendButton.classList.add('is-stop')
    sendButton.innerHTML = icons.stop
    responseStatus.textContent = demoMode ? t('statusPreviewDone') : t('statusOpeningConversation')
  }

  const redirect = () => {
    if (finished) return
    finished = true
    abortController.abort()
    output.textContent = prompt
    placeholder.hidden = true
    setProgress(chars.length)
    caret.classList.add('done')
    progressCopy.textContent = demoMode ? t('statusPreviewDone') : t('statusOpeningChatGPT')
    setStatus(demoMode ? t('statusPreviewDone') : t('statusSendingChatGPT'))
    composer.classList.add('is-sending')
    sendButton.classList.add('ready')

    setTimeout(showSentState, reducedMotion ? 20 : 220)

    if (demoMode) {
      setTimeout(() => {
        skipButton.innerHTML = `${icons.external}<span>${t('openInChatGPT')}</span>`
        skipButton.title = t('openInChatGPT')
        skipButton.setAttribute('aria-label', 'Abrir no ChatGPT')
        pauseButton.hidden = true
      }, reducedMotion ? 30 : 420)
      return
    }

    setTimeout(() => {
      document.querySelector('#fallback-card').hidden = false
    }, 5000)
    setTimeout(() => window.location.assign(buildChatGptUrl(prompt)), reducedMotion ? 180 : 1250)
  }

  const type = async () => {
    await sleep(reducedMotion ? 30 : 500, abortController.signal)
    placeholder.hidden = true
    progressCopy.textContent = t('statusTyping')
    for (let i = 0; i < chars.length; i += 1) {
      if (finished) return
      while (paused && !finished) await sleep(80, abortController.signal)
      output.textContent += chars[i]
      if (i === 0) sendButton.classList.add('ready')
      setProgress(i + 1)
      const punctuationPause = /[.!?;:]$/.test(chars[i]) ? 115 : /[,\n]$/.test(chars[i]) ? 75 : 0
      await sleep(reducedMotion ? 0 : randomBetween(timing.min, timing.max) + punctuationPause, abortController.signal)
    }
    progressCopy.textContent = t('statusQuestionComplete')
    setStatus(t('statusQuestionReady'))
    await sleep(reducedMotion ? 120 : 620, abortController.signal)
    redirect()
  }

  pauseButton.addEventListener('click', () => {
    if (finished) return
    paused = !paused
    pauseButton.innerHTML = paused ? `${icons.play}<span>${t('continue')}</span>` : `${icons.pause}<span>${t('pause')}</span>`
    pauseButton.title = paused ? t('continueAnimation') : t('pauseAnimation')
    pauseButton.setAttribute('aria-label', pauseButton.title)
    setStatus(paused ? t('statusPaused') : t('statusTypingQuestion'))
  })

  skipButton.addEventListener('click', () => {
    if (demoMode && finished) {
      window.location.assign(buildChatGptUrl(prompt))
      return
    }
    redirect()
  })

  const copyPromptButton = document.querySelector('#copy-prompt')
  copyPromptButton?.addEventListener('click', async () => {
    const source = document.querySelector('#prompt-copy-source')
    if (await copyText(prompt, source)) showToast(t('statusQuestionCopied'))
  })

  type()
}

async function initializeApp() {
  const resolved = await resolveInitialLanguage()
  currentLocale = resolved.locale
  languageMode = resolved.mode
  applyLocaleMetadata()
  if (sharedPrompt) renderPlayer(sharedPrompt)
  else renderHome()
}

initializeApp()
